import config from "../../../../config";
import { ResponseDto } from '../../../../dtos/common/responseDto';
import { deleteData, getData, getPostData, patchData, postData } from '../../../../utils/axios/serverHelper';
import { formatDate } from '../../../../utils/string/stringUtil';
import axios from 'axios';

import { SAL2070_R01Dto, } from './Dto_SAL2070_R01';
import { SAL2070_R01Filter } from "./Store_SAL2070_R01";

const baseUrl = `${config.apiUrl}/SAL2070_R01`;

const getParams = (filter: Partial<SAL2070_R01Filter>, listLength?: number) => {	
	return {
		compCd: filter.compCd || undefined,
		startDate: filter.dateRange?.from ? formatDate(filter.dateRange.from) : undefined,
		endDate: filter.dateRange?.to ? formatDate(filter.dateRange.to) : undefined,
		taxBilling: filter.taxBilling || undefined,
		tradeType: filter.tradeType || undefined,
		customCd: filter.customCd || undefined,

		listLength: listLength || 0
	}
}

export const getSAL2070_R01List = async (option: string, params: Partial<SAL2070_R01Filter>, listLength: number = 0) => {

	const url = `${baseUrl}/${option}`;

	return await getData<ResponseDto<SAL2070_R01Dto[]>>(url, { params: getParams(params, listLength) });
}

export const getSAL2070_R01DetailInfo = async (data: SAL2070_R01Dto) => {
	const url = `${baseUrl}/detail/info`;

	return await getData<ResponseDto<SAL2070_R01Dto>>(url, { params: data });
}

export const getSAL2070_R01DetailList = async (data: SAL2070_R01Dto) => {
	const url = `${baseUrl}/detail/list`;

	//detail 조회시 tradeNoList 초기화
	data.tradeNoList = [];

	return await getData<ResponseDto<SAL2070_R01Dto[]>>(url, { params: data });
}

export const getSAL2070_R01CreateInfo = async (data: SAL2070_R01Dto) => {
	const url = `${baseUrl}/create/info`;

	/*
	taxBilling = Y, tradeType, tradeDt, customCd, taxEmpNo 정보를 보내서 메인 그리드에 추가될 세금계산서 정보를 조회
	 */

	return await getData<ResponseDto<SAL2070_R01Dto>>(url, { params: data });
}

export const postSAL2070_R01 = async (data: SAL2070_R01Dto, tradeNoList: string[]) => {

	const url = `${baseUrl}`;

	return await postData<SAL2070_R01Dto, ResponseDto<SAL2070_R01Dto>>(url, {
		...data,
		tradeNoList: tradeNoList
	});
}


export const deleteSAL2070_R01 = async (data: SAL2070_R01Dto, tradeNoList: string[]) => {

	const url = `${baseUrl}`;

	return await deleteData<ResponseDto<SAL2070_R01Dto>>(url, {
		params: {
			...data,
			tradeNoList: tradeNoList
		}
	});
}

export const downloadExcel_SAL2070_R01 = async (option: string, tradeNo: string, listLength: number = 0) => {
	const url = `${baseUrl}/excel/${option}`

	return await getData<ResponseDto<string>>(url, {
		params: {
			tradeNo
		}
	})
}
export const getPdfBlob_SAL2070_R01 = async (taxBillNo: string, mode: 'AGG' | 'EXPAND' = 'AGG'): Promise<Blob> => {
	const url = `${baseUrl}/print`;
	const response = await getData<Blob>(url, {
		params: { taxBillNo, mode },
		responseType: "blob",
	});
	return new Blob([response.data], { type: "application/pdf" });
};